import { getViewGameFreespin } from '../api/getViewGameFreespin';
import {setGetViewGameFreespinAction} from '../action';

const setGetViewGameFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getViewGameFreespin(params);

            if (data.status === 'success') {
                dispatch(setGetViewGameFreespinAction({
                    ...data.data
                }));
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetViewGameFreespin
}